import sanityClient from '@sanity/client'
export default sanityClient({
    "projectId": "qok3a1f3",
    "dataset": "production"
})